import AssessmentServiceApi from "../../services/assessment-api";

const updateUserPlan = (data) => {
  return function () {
    return AssessmentServiceApi.updateUserPlan(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const addGuestUsersBulk = (data) => {
  return function () {
    return AssessmentServiceApi.addGuestUsersBulk(data);
  };
};

export { updateUserPlan, addGuestUsersBulk };
